import type { Material } from './material.interface';

export interface cv_MaterialOrigin {
    C_MaterialOrigin_key: number;
    C_VocabularySource_key: number | null;
    C_Workgroup_key: number;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsDeprecated: boolean;
    Material: Material[];
    MaterialOrigin: string;
    ModifiedBy: string;
    SortOrder: number | null;
    Version: number;
}
